export function PrimaryButton({href="",primaryText,secondaryText=null,icon}){


    return(
        <a href={href}
           target="blank"
           className={"btn btn-extra-large btn-gradient-light-pink-light-purple btn-rounded"+
               (secondaryText ? " btn-switch-text " : "")
               +" ls-0px me-10px mt-15px"}
        >
            <span>
                <span className="btn-double-text"
                  {...(secondaryText ? { "data-text": secondaryText.toUpperCase() } : {})}
                >
                    {primaryText.toUpperCase()}
                </span>
                {icon && <span><i className={icon}></i></span>}
            </span>
        </a>
    )
}

export function SecondaryButton({href="",primaryText,secondaryText,icon}){


    return(
        <a href={href}
           className="btn btn-extra-large btn-switch-text btn-transparent-white-light btn-rounded border-1 ls-0px mt-15px"> <span> <span
            className="btn-double-text"
            data-text={secondaryText.toUpperCase()}>{primaryText.toUpperCase()}</span>
            {icon && <span><i className={icon}></i></span>}
        </span> </a>
    )
}